import { useAppSelector } from 'hooks/reduxHooks'

const EmptyItemState: App.UserCartItemState = {
  saveForLater: false,
  deleted: false,
}

export function useUserCartItemState(itemId: string): App.UserCartItemState {
  return useAppSelector(state => state.auth.userCart.itemStates[itemId]) ?? EmptyItemState
}
